import { Button, Modal } from '@heroui/react';
import type { ComponentProps, ReactNode } from 'react';

// 受控弹窗封装:收敛 Modal 五层结构,贴 TDesign Dialog 心智
// 传 onConfirm 生成标准「取消/确定」页脚;传 footer 完全自定义;都不传则无页脚
export function AppModal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  onConfirm,
  confirmText = '确定',
  cancelText = '取消',
  confirmLoading,
  confirmDisabled,
  danger,
  size,
  bodyClassName,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmLoading?: boolean;
  confirmDisabled?: boolean;
  danger?: boolean;
  size?: ComponentProps<typeof Modal.Container>['size'];
  bodyClassName?: string;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <Modal.Backdrop>
        <Modal.Container size={size}>
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Heading>{title}</Modal.Heading>
            </Modal.Header>
            {children ? (
              <Modal.Body className={bodyClassName}>{children}</Modal.Body>
            ) : null}
            {footer ? (
              <Modal.Footer>{footer}</Modal.Footer>
            ) : onConfirm ? (
              <Modal.Footer>
                <Button variant="ghost" onPress={onClose}>
                  {cancelText}
                </Button>
                <Button
                  variant={danger ? 'danger' : 'primary'}
                  isPending={confirmLoading}
                  isDisabled={confirmDisabled}
                  onPress={onConfirm}
                >
                  {confirmText}
                </Button>
              </Modal.Footer>
            ) : null}
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  );
}
